module.exports = __webpack_public_path__ + "ee6ac766/img/arrow-left-icon.785c715c.svg";